export default __webpack_public_path__ + "static/media/rotate.755d75f3.svg";